<template>
  <div id="data-edit-tab-info">

    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">
        <div class="mt-4">
          <label class="vs-input--label">Bill Type</label>
          <v-select :options="optionBillType" :reduce="name => name.id" label="name" v-validate="'required'" v-model="data_local.bill_type_id" name="bill_type_id"/>
          <span class="text-danger text-sm"  v-show="errors.has('bill_type_id')">{{ errors.first('bill_type_id') }}</span>        
        </div>  

        <vs-input class="w-full mt-4" label="Amount" v-model="data_local.amount" v-validate="'required'" name="amount" />
        <span class="text-danger text-sm"  v-show="errors.has('amount')">{{ errors.first('amount') }}</span>

        <vs-input class="w-full mt-4" label="Description" v-model="data_local.description" v-validate="'required'" name="description" />
        <span class="text-danger text-sm"  v-show="errors.has('description')">{{ errors.first('description') }}</span> 
        
        <vs-input class="w-full mt-4" label="Due Date" v-model="data_local.due_date" v-validate="'required'" name="due_date" type="date"/>
        <span class="text-danger text-sm"  v-show="errors.has('due_date')">{{ errors.first('due_date') }}</span>  
      </div>

      <div class="vx-col md:w-1/2 w-full">
        <div class="mt-4">
          <label class="vs-input--label">Unit</label>
          <v-select :options="optionUnit" :reduce="number => number.id" label="number" v-validate="'required'" v-model="data_local.unit_id" name="unit_id"/>
          <span class="text-danger text-sm"  v-show="errors.has('unit_id')">{{ errors.first('unit_id') }}</span>  
        </div>

        <div class="mt-4">
          <label class="vs-input--label">Property</label>
          <v-select :options="optionProperty" :reduce="name => name.id" label="name" v-validate="'required'" v-model="data_local.property_id" name="property_id"/>
          <span class="text-danger text-sm"  v-show="errors.has('property_id')">{{ errors.first('property_id') }}</span>
        </div>
      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="submit('a')" :disabled="!validateForm">Save and New</vs-button>
          <vs-button class="ml-4 mt-2" @click="submit('b')" :disabled="!validateForm">Save and Close</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Reset</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import axios from '../../../../axios'
import approval from '../../../components/approval-widget/approval'

export default {
  components: {
    vSelect,
    approval
  },
  data () {
    return {
      token: localStorage.usertoken,
      optionBillType: [],
      optionUnit: [],
      optionProperty: [],

      //billing
      data_local: {
        unit_resident_id: '',
        bill_type_id: '',
        amount: '',
        due_date: '',
        generated_date: '',
        from_date: '',
        to_date: '',
        description: '',
        payer_name: '',
        payer_email: this.$route.query.email,
        payer_address: '',
        payer_phone: '',
        payee_name: '',
        payee_email: '',
        payee_phone: '',
        payee_address: '',
        status: '',
        bill_config_id: '',
        unit_id: '',
        property_id: '',
        approvals: [],
      },

      statusOptions: [
        { label: 'Active',  value: 'active' },
        { label: 'Blocked',  value: 'blocked' },
        { label: 'Deactivated',  value: 'deactivated' }
      ],
      roleOptions: [
        { label: 'Admin',  value: 'admin' },
        { label: 'User',  value: 'user' },
        { label: 'Staff',  value: 'staff' }
      ]
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any()
    }
  },
  methods: {
    capitalize (str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length)
    },
    submit(loc) {
      this.$validator.validateAll()
      .then(result => {
        if(result) {
          this.save_changes(loc)
        }
      })
    },
    async save_changes (loc) {
      if (!this.validateForm) return
        try {    
          await axios.post(`/billing/save/`, 
            this.data_local, 
            { headers: { 'Authorization': this.token } });

           if (loc === 'a') {
              setTimeout(() => {
                window.location.href = "/billings/new";
              },500)
            } else {
              this.$router.push({name:'app-billing-list'})
            }
        } catch({ response }) {
          this.$vs.notify({
            color: 'danger',
            title: 'Data Saving Error',
            text: response.data.errors,
          })
        }
    },
    reset_data () {
      //billing
      this.data_local['unit_resident_id'] = ''
      this.data_local['bill_type_id'] = ''
      this.data_local['amount'] = ''
      this.data_local['due_date'] = ''
      this.data_local['generated_date'] = ''
      this.data_local['from_date'] = ''
      this.data_local['to_date'] = ''
      this.data_local['description'] = ''
      this.data_local['payer_name'] = ''
      this.data_local['payer_email'] = ''
      this.data_local['payer_address'] = ''
      this.data_local['payer_phone'] = ''
      this.data_local['payee_name'] = ''
      this.data_local['payee_email'] = ''
      this.data_local['payee_phone'] = ''
      this.data_local['payee_address'] = ''
      this.data_local['status'] = ''
      this.data_local['bill_config_id'] = ''
      this.data_local['unit_id'] = ''
      this.data_local['property_id'] = ''

      this.$vs.notify({
        color: 'orange',
        title: 'Data Edit',
        text: 'The selected Data data was reset'
      })
    },
    update_avatar () {
      // You can update avatar Here
      // For reference you can check dataList example
      // We haven't integrated it here, because data isn't saved in DB
    },
    loadBillType () {
      var d = new Promise( async (resolve, reject)  => {
        try {    
          await axios.get(`/api/billType/list`, {
              headers: { 'Authorization': this.token }
            })
            .then(res => {     
              resolve(res['data'])
            })
            .catch(err => {
              reject(err.toString('utf8'));
            }) 
        } catch(err) {
          reject(err.toString('utf8'));
        }  
      })

      d.then((res) => {
        console.log('res bill type ', res)
        this.optionBillType = res
      })
    },
    loadProperty () {
      var d = new Promise( async (resolve, reject)  => {
        try {    
          await axios.get(`/api/property/list`, {
              headers: { 'Authorization': this.token }
            })
            .then(res => {     
              resolve(res['data'])
            })
            .catch(err => {
              reject(err.toString('utf8'));
            }) 
        } catch(err) {
          reject(err.toString('utf8'));
        }  
      })

      d.then((res) => {
        console.log('res loadProperty ', res)
        this.optionProperty = res
      })
    },
    loadUnit () {
      var d = new Promise( async (resolve, reject)  => {
        try {    
          await axios.get(`/unit/list`, {
              headers: { 'Authorization': this.token, 'property_ref': localStorage.selectedParentOrgRef }
            })
            .then(res => {     
              resolve(res['data'])
            })
            .catch(err => {
              reject(err.toString('utf8'));
            }) 
        } catch(err) {
          reject(err.toString('utf8'));
        }  
      })

      d.then((res) => {
        console.log('res loadUnit ', res)
        this.optionUnit = res
      })
    }
  },
  created () {
    this.loadBillType()
    this.loadProperty()
    this.loadUnit()
  }
}
</script>
